<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <div class="row">
          <div class="card">
            <div class="card-body">
              <div class="mb-1">
                <span class="mt-2">Para dar andamento à sua solicitação, pedimos que você confirme seus dados de contato e informações bancárias.</span> <br>
                <span>É importante lembrar que manter o cadastro pessoal atualizado é uma obrigação estatutária, conforme mencionado no Estatudo Social da 
                  Cooperativa. <br>
                </span>
                <span>Art. 06 "São deveres e obrigações do assiciado Manter seu cadastro atualizado junto a Cooperativa"</span>
              </div>
              <div class="my-2">
                <div class="row">
                  <h4>Telefone</h4>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group class="mb-3" label="Telefone">
                      <b-form-input
                        v-model="dadosTelefone.telefone"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group class="mb-3" label="Tipo Telefone">
                      <b-form-input
                        v-model="dadosTelefone.tpTelefone"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group class="mb-3" label="Principal?">
                      <b-form-input
                        v-model="dadosTelefone.stPrincipalTelefone"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="my-2">
                <div class="row">
                  <h4>E-mail</h4>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group
                      class="mb-3"
                      label="E-mail"
                    >
                      <b-form-input
                        v-model="dadosEmail.email"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group class="mb-3" label="Tipo E-mail">
                      <b-form-input
                      v-model="dadosEmail.tpEmail"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group class="mb-3" label="Principal?">
                      <b-form-input
                        v-model="dadosEmail.stPrincipalEmail"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <div class="my-2">
                <div class="row">
                  <h4>Informações Bancárias</h4>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group
                      class="mb-3"
                      label="Banco"
                    >
                      <b-form-input
                        v-model="dadosInfoBancarias.banco"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group class="mb-3" label="Agência">
                      <b-form-input
                        v-model="dadosInfoBancarias.agencia"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group class="mb-3" label="N° da Conta?">
                      <b-form-input
                      v-model="dadosInfoBancarias.nrConta"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group
                      class="mb-3"
                      label="DV"
                    >
                      <b-form-input
                      v-model="dadosInfoBancarias.DV"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group class="mb-3" label="Tipo de Conta">
                      <b-form-input
                        v-model="dadosInfoBancarias.tpConta"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group class="mb-3" label="Principal?">
                      <b-form-input
                        v-model="dadosInfoBancarias.stPrincipalBanco"
                        type="text"
                        :disabled="true"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <span>Se precisar fazer alguma alteração nas informações, acesse o menu lateral esquedo, clique em "Cadastro Pessoal" e acesse o "Perfil Pessoal".</span>
                </div>

                <div class="row">
                  <div class="mt-1 d-flex justify-content-between">
                    <div class="d-flex flex-column">
                      <router-link :to="'/perfilPessoal/cadastroPessoal'">
                        <b-button size="md" class="mb-3"> 
                          <i class=" mdi mdi-arrow-left"></i>
                          Retornar e atualizar os dados
                        </b-button>
                      </router-link>
                      <router-link :to="'/cooperado/contaCapital'">
                        <b-button size="md"  variant="secondary"> 
                          <i class="mdi mdi-arrow-left"></i>
                          Voltar
                        </b-button>
                      </router-link>
                    </div>
                    <div>                    
                      <b-button
                        class="mt-1 me-1 "
                        variant="success"
                        data-tooltip="Confirmar"
                        data-tooltip-location="bottom"
                        @click="mostraMensagem()"
                      >
                        Confirmar os dados e continuar
                        <i class=" mdi mdi-arrow-right"></i>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";

const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};
export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      title: "Confirmar Dados de Desligamento",
      items: [
        {
          text: "Conta Capital",
          active: false,
          href: "/cooperado/contaCapital",
        },
        {
          text: "Confirmar Dados de Desligamento",
          active: true
        },
        {
          text: this.$store.state.nrMatricula,
          active: true
        },
      ],
      loading: true,
      dadosTelefone: {
        telefone: "",
        tpTelefone: "",
        stPrincipalTelefone: "",
      },
      dadosEmail: {
        email: "",
        tpEmail: "",
        stPrincipalEmail: "",
      },
      dadosInfoBancarias: {
        banco: "",
        agencia: "",
        nrConta: "",
        DV: "",
        tpConta: "",
        stPrincipalBanco: "",
      },
      bloqueiaContinuar: false
    };
  },
  async created() {
    this.$tools.fecharMenu();
    await this.buscaInformacoesUsuario();
  },
  methods: {
    async buscaInformacoesUsuario() {
      this.bloqueiaContinuar = false
      try {
        const [validarDados] =
        await Promise.all([
          this.$http.get("api/desligamento/validarDados"),
        ]);
        var respTelefone = validarDados.data.telefones[0]
        var respEmail = validarDados.data.emails[0]
        var respInfoBanco = validarDados.data.dadosBancarios[0]
        if(!respTelefone || !respEmail || !respInfoBanco){
          this.bloqueiaContinuar = true
        }
        if(respTelefone){
          this.dadosTelefone.telefone = '('+respTelefone.NRDDD+') '+ respTelefone.NRTELEFONE
          this.dadosTelefone.tpTelefone = capitalizeString(respTelefone.NMTIPO)
          this.dadosTelefone.stPrincipalTelefone = respTelefone.PRINCIPAL
        }
        if(respEmail){
          this.dadosEmail.email = respEmail.DSEMAIL
          this.dadosEmail.tpEmail = capitalizeString(respEmail.NMTIPO)
          this.dadosEmail.stPrincipalEmail = respEmail.PRINCIPAL
        }
        if(respInfoBanco){
          this.dadosInfoBancarias.banco = capitalizeString(respInfoBanco.NMBCO)
          this.dadosInfoBancarias.agencia = capitalizeString(respInfoBanco.NMAGENCIA)
          this.dadosInfoBancarias.nrConta = respInfoBanco.NRCTA
          this.dadosInfoBancarias.DV = respInfoBanco.DVCTA
          this.dadosInfoBancarias.tpConta = respInfoBanco.CONTA
          this.dadosInfoBancarias.stPrincipalBanco = respInfoBanco.PRINCIPAL
        }
      } catch (error) {
        // Lida com erros, se necessário
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loading = false;
      }
    },
    mostraMensagem(){
      if(this.bloqueiaContinuar == true){
        this.$tools.alerta(
            "Para continuar é nescessário ter um Telefone, um E-mail e uma Conta Bancária PRINCIPAL",
            "warning"
          );
          return;
      }else{
        this.$router.push("/cooperado/contaCapital/desligamento/justificativaDesligamento")
      }
    }
  },
};
</script>